import { diffWordsWithSpace } from "diff";

/**
 * Word-level diff between two strings.
 * Returns array of {value, added, removed} chunks.
 */
export function wordDiff(a, b) {
  if (!a && !b) return [];
  return diffWordsWithSpace(a || "", b || "");
}

export function DiffView({ original, revised, testId = "diff-view" }) {
  const parts = wordDiff(original, revised);
  return (
    <div
      data-testid={testId}
      className="thin-scroll max-h-[420px] flex-1 overflow-y-auto whitespace-pre-wrap rounded-xl bg-white p-4 font-body text-[15px] leading-relaxed text-slate-800 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)]"
    >
      {parts.map((p, i) => {
        if (p.added) {
          return (
            <span
              key={i}
              data-testid={`diff-added-${i}`}
              className="rounded bg-emerald-100 px-0.5 text-emerald-800"
            >
              {p.value}
            </span>
          );
        }
        if (p.removed) {
          return (
            <span
              key={i}
              data-testid={`diff-removed-${i}`}
              className="rounded bg-red-100 px-0.5 text-red-700 line-through decoration-red-500/70"
            >
              {p.value}
            </span>
          );
        }
        return <span key={i}>{p.value}</span>;
      })}
    </div>
  );
}
